import { VIANUVEM_API_ENDPOINT } from "../integrations/Defaults";

const Token = {
    validate: (token) => {
        return new Promise((resolve,reject) => {
            fetch(`${VIANUVEM_API_ENDPOINT}/public/users/token/validate/${token}`)
                .then(response => {
                    if (+response.status !== 200) {
                        reject('Token inválido');
                    }

                    resolve();
                })
                .catch(reject)
        });
    }
};

export default Token;



// WEBPACK FOOTER //
// ./src/utility/token.js